import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

// Keep English as the canonical default; explicit URL and saved choices win.
const detectLang = () => {
  if (typeof window !== "undefined") {
    const requested = new URLSearchParams(window.location.search).get("lang");
    if (requested === "bg" || requested === "en") return requested;
  }
  try {
    const saved = localStorage.getItem("casabala_lang");
    if (saved === "bg" || saved === "en") return saved;
  } catch (e) { /* ignore */ }
  return "en";
};

const dict = {
  bg: {
    // Navigation
    "nav.home": "Начало",
    "nav.menu": "Меню",
    "nav.reservation": "Резервация",
    "nav.order": "Поръчай",
    "nav.gallery": "Галерия",
    "nav.events": "Събития",
    "nav.about": "За нас",
    "nav.video": "Видео",
    "nav.contact": "Контакти",
    "nav.profile": "Профил",
    "nav.cta_order": "ПОРЪЧАЙ",

    // Hero
    "hero.welcome": "Добре дошли в",
    "hero.tagline": "Насладете се на Средиземноморски вкус!",
    "hero.reservation": "Резервация",

    // Offerings
    "offerings.label": "Вкус за Ценители",
    "offerings.title": "Нашите Предложения",
    "offerings.welcome": "Добре дошли!",
    "offerings.experience": "Незабравимо преживяване",
    "offerings.experience_cta": "Направи резервация",
    "offerings.tastes": "Средиземноморски Вкусове",
    "offerings.see_menu": "Вижте меню",
    "offerings.wine": "Вино",

    // About story
    "story.label": "Нашата история",
    "story.title": "Вкусове с различна история",
    "story.body":
      "Каним ви в лежерна средиземноморска атмосфера. Нашата локация на Симеоновско шосе 4 (в сградата на Hotel Hayashi) предлага автентичен дух в модерна и комфортна обстановка.",
    "story.call": "Обадете се за резервация:",
    "story.more": "Повече",

    // Reservations
    "res.title": "Резервации",
    "res.only_phone": "Резервациите се правят само по телефон",
    "res.call_to_reserve": "Обадете се за да резервирате:",
    "res.hours_label": "Работно време за резервации:",
    "res.contact_us": "Свържете се с нас",
    "res.location": "Локация",
    "res.work_hours": "Работно време",
    "res.click_to_call": "Кликнете за обаждане",
    "res.book_with_us": "Запазете маса при нас",
    "res.group_note":
      "За групи над 8 души, моля свържете се с нас предварително за персонализирано обслужване.",

    // Features
    "features.label": "Защо CASA BALA",
    "features.title": "Нашите предимства",
    "features.fresh": "Свежи продукти",
    "features.fresh_desc": "Свежи морски дарове и сезонни продукти всеки ден.",
    "features.tastes": "Средиземноморски Вкусове",
    "features.tastes_desc":
      "Автентични ястия, вдъхновени от кулинарните традиции на региона.",
    "features.chefs": "Майстори Готвачи",
    "features.chefs_desc":
      "Професионален екип, създаващ изискани ястия с перфектни детайли.",
    "features.events": "Събития",
    "features.events_desc":
      "Вашият специален повод, незабравимо при нас. Персонализирано обслужване и меню.",

    // Menu
    "menu.label": "Разгледай нашето меню",
    "menu.title": "Меню",
    "menu.lunch": "Обедно меню",
    "menu.lunch_hours": "12:00 - 14:00",
    "menu.lunch_desc":
      "Специално предложение за обяд с бързо и вкусно хранене. Перфектно за бизнес срещи или бърз обяд по време на работния ден.",
    "menu.main": "Основно меню",
    "menu.main_desc":
      "Пълното ни меню с всички специалитети. От традиционни средиземноморски ястия до модерни интерпретации. Включва предястия, основни ястия, паста, пица, десерти и др.",
    "menu.drinks": "Безалкохолни Напитки",
    "menu.drinks_desc":
      "Открийте безалкохолни напитки, които прекрасно съчетаваме с нашите ястия.",
    "menu.alcohol": "Алкохолни Напитки",
    "menu.alcohol_desc":
      "Вина, алкохол, коктейли, бира. Избираме напитките, които наистина допълват ястията ни.",
    "menu.see_menu": "Разгледай менюто",
    "menu.category": "Категория",
    "menu.weight": "Грамаж",
    "menu.price": "Цена",
    "menu.add": "Добави",
    "menu.add_to_order": "Добави в поръчката",
    "menu.no_items": "Скоро ще добавим продукти в тази категория.",
    "menu.back": "Назад към глвно меню",
    // Categories
    "cat.MAIN": "Основни",
    "cat.SALAD": "Салати",
    "cat.STARTER": "Антипасти",
    "cat.SOUP": "Супи",
    "cat.PASTA": "Паста",
    "cat.RISOTTO": "Ризото",
    "cat.PIZZA": "Пица",
    "cat.SIDES": "Гарнитури",
    "cat.BREAD": "Хляб",
    "cat.DESSERT": "Десерти",

    // Order
    "order.label": "Поръчай при нас",
    "order.title": "Поръчки",
    "order.phone_only": "Поръчките се правят само по телефон",
    "order.call_to_order": "Обадете се за да направите поръчка:",
    "order.click_to_call": "Кликнете за обаждане",
    "order.hours_label": "Работно време за поръчки:",
    "order.delivery_note":
     "За доставка моля посочете адрес при обаждането. Очакваме ви също на място в ресторанта.",
    "order.see_menu_first": "Разгледай менюто",
    "order.cart": "Поръчка",
    "order.empty": "Все още няма добавени продукти.",
    "order.to_menu": "Към менюто",
    "order.products": "Продукти",
    "order.delivery": "Доставка",
    "order.delivery_tbd": "следва да се изчисли",
    "order.total": "Общо",
    "order.checkout": "Към плащане",
    "order.added": "Добавено в поръчката",
    "order.accepted": "Поръчката е приета!",
    "order.accepted_desc": "Ще ви се обадим за потвърждение.",

    // Gallery
    "gallery.label": "Нашите моменти",
    "gallery.title": "Галерия",
    "gallery.subtitle":
      "Погледнете в света на CASA BALA – нашата атмосфера, ястията и моментите, които създаваме всеки ден.",

    // Events
    "events.label": "Незабравими моменти",
    "events.title": "Събития",
    "events.subtitle":
      "От винени вечери до частни тържества – CASA BALA е перфектното място за вашите специални моменти.",
    "events.upcoming": "Предстоящи събития",
    "events.past": "Минали събития",
    "events.no_past": "Скоро ще добавим информация за минали събития.",
    "events.see_more": "Виж повече",
    "events.book": "Резервирай",
    "events.back": "Назад към събитията",
    "events.date_time": "Дата и час",
    "events.place": "Място",
    "events.music_theme": "Тематична музика",
    "events.program": "Програма на вечерта",
    "events.special_menu": "Специално Меню",
    "events.reservations": "Резервации",

    // About
    "about.label": "Нашата история",
    "about.title": "Вкусове със собствена история",
    "about.team_label": "Екипът зад който стои всичко",
    "about.team_title": "Нашите Готвачи",
    "about.team_subtitle": "Екип",
    "about.team_heading": "Нашият екип",
    "about.goals_label": "Цели",
    "about.goals_title": "Нашите цели",
    "about.history_label": "История",
    "about.history_title": "История",

    // Contact
    "contact.label": "Свържете се с нас",
    "contact.title": "Контакти",
    "contact.location": "Локация",
    "contact.phone": "Телефон",
    "contact.email": "Имейл",
    "contact.hours": "Работно време",
    "contact.send_message": "Изпратете съобщение",
    "contact.name": "Име",
    "contact.email_label": "Имейл",
    "contact.message": "Съобщение",
    "contact.send": "Изпрати",
    "contact.thanks": "Благодарим ви!",
    "contact.thanks_desc":
      "Съобщението ви бе изпратено. Ще ви отговорим в най-кратките възможни срокове.",

    // Footer
    "footer.tagline":
      "Средиземноморски ресторант в сърцето на София. Автентични вкусове, свежи продукти и топла атмосфера.",
    "footer.navigation": "Навигация",
    "footer.contacts": "Контакти",
    "footer.follow": "Следвайте ни",
    "footer.our_chefs": "Нашите готвачи",
    "footer.rights": "Всички права запазени.",
    "footer.with_love": "Създадено с любов към Средиземноморието",

    // Common
    "common.opening_hours": "Всеки ден: от 12:00 - 24:00ч.",
    "common.reservation_hours": "Всеки ден: от 10:00 до 22:00 часа",
    "common.work_days": "Понеделник - Неделя",

      // В dict.bg добавете:
"events.wine_evenings": "Винени Вечери",
"events.every_friday": "Всеки петък",
"events.wine_evenings_desc": "Дегустация на селектирани вина в комбинация с авторски ястия от нашия шеф.",
"events.live_music": "Жива музика",
"events.every_saturday": "Всяка събота",
"events.live_music_desc": "Насладете се на жива музика, докато опитвате нашите средиземноморски деликатеси.",
"events.private_events": "Частни събития",
"events.by_request": "По заявка",
"events.private_events_desc": "Организираме рождени дни, годежи и корпоративни събития с персонализирано меню.",
"events.culinary_classes": "Кулинарни майсторски класове",
"events.once_monthly": "Веднъж месечно",
"events.culinary_classes_desc": "Научете тайните на средиземноморската кухня от нашите шеф готвачи.",
"contact.street": 'бул. "Симеоновско шосе" 4',
"contact.city": "София, България",
"contact.address": 'бул. "Симеоновско шосе" 4, София, България',
  },



  en: {
    // Navigation
    "nav.home": "Home",
    "nav.menu": "Menu",
    "nav.reservation": "Reservation",
    "nav.order": "Order",
    "nav.gallery": "Gallery",
    "nav.events": "Events",
    "nav.about": "About",
    "nav.video": "Video",
    "nav.contact": "Contact",
    "nav.profile": "Profile",
    "nav.cta_order": "ORDER",

    // Hero
    "hero.welcome": "Welcome to",
    "hero.tagline": "Enjoy a Mediterranean taste!",
    "hero.reservation": "Reservation",

    // Offerings
    "offerings.label": "A Taste for Connoisseurs",
    "offerings.title": "Our Offerings",
    "offerings.welcome": "Welcome!",
    "offerings.experience": "Unforgettable Experience",
    "offerings.experience_cta": "Make a Reservation",
    "offerings.tastes": "Mediterranean Flavors",
    "offerings.see_menu": "View Menu",
    "offerings.wine": "Wine",

    // About story
    "story.label": "Our Story",
    "story.title": "Tastes with a Different Story",
    "story.body":
      "We invite you to a relaxed Mediterranean atmosphere. Our location at Simeonovsko Shose 4 (in the Hotel Hayashi building) offers an authentic spirit in a modern and comfortable setting.",
    "story.call": "Call for a reservation:",
    "story.more": "More",

    // Reservations
    "res.title": "Reservations",
    "res.only_phone": "Reservations are made by phone only",
    "res.call_to_reserve": "Call us to book your table:",
    "res.hours_label": "Reservation hours:",
    "res.contact_us": "Get in touch",
    "res.location": "Location",
    "res.work_hours": "Opening hours",
    "res.click_to_call": "Click to call",
    "res.book_with_us": "Book your table with us",
    "res.group_note":
      "For groups of more than 8, please contact us in advance for personalized service.",

    // Features
    "features.label": "Why CASA BALA",
    "features.title": "Our Advantages",
    "features.fresh": "Fresh Ingredients",
    "features.fresh_desc": "Fresh seafood and seasonal produce every single day.",
    "features.tastes": "Mediterranean Flavors",
    "features.tastes_desc":
      "Authentic dishes inspired by the culinary traditions of the region.",
    "features.chefs": "Master Chefs",
    "features.chefs_desc":
      "A professional team crafting refined dishes with perfect attention to detail.",
    "features.events": "Events",
    "features.events_desc":
      "Your special occasion, unforgettable with us. Personalized service and menu.",

    // Menu
    "menu.label": "Explore our menu",
    "menu.title": "Menu",
    "menu.lunch": "Lunch Menu",
    "menu.lunch_hours": "12:00 - 14:00",
    "menu.lunch_desc":
      "A special lunch offer for quick and delicious meals. Perfect for business meetings or a fast lunch during the workday.",
    "menu.main": "Main Menu",
    "menu.main_desc":
      "Our full menu with all the specialties. From traditional Mediterranean dishes to modern interpretations. Includes starters, mains, pasta, pizza, desserts and more.",
    "menu.drinks": "Soft Drinks",
    "menu.drinks_desc":
      "Discover the non-alcoholic drinks we love pairing with our dishes.",
    "menu.alcohol": "Alcoholic Drinks",
    "menu.alcohol_desc":
      "Wines, spirits, cocktails, beer. We pick the drinks that truly complement our dishes.",
    "menu.see_menu": "View Menu",
    "menu.category": "Category",
    "menu.weight": "Weight",
    "menu.price": "Price",
    "menu.add": "Add",
    "menu.add_to_order": "Add to order",
    "menu.no_items": "We'll be adding items to this category soon.",
    "menu.back": "Back to main menu",
    
    "cat.MAIN": "Mains",
    "cat.SALAD": "Salads",
    "cat.STARTER": "Antipasti",
    "cat.SOUP": "Soups",
    "cat.PASTA": "Pasta",
    "cat.RISOTTO": "Risotto",
    "cat.PIZZA": "Pizza",
    "cat.SIDES": "Sides",
    "cat.BREAD": "Bread",
    "cat.DESSERT": "Desserts",

    // Order
    "order.label": "Order with us",
    "order.title": "Orders",
    "order.phone_only": "Orders are taken by phone only",
    "order.call_to_order": "Call us to place an order:",
    "order.click_to_call": "Click to call",
    "order.hours_label": "Order hours:",
    "order.delivery_note":
      "For delivery, please provide the address when you call. You are also welcome to dine in.",
    "order.see_menu_first": "View the menu",
    "order.cart": "Order",
    "order.empty": "No items added yet.",
    "order.to_menu": "Go to Menu",
    "order.products": "Items",
    "order.delivery": "Delivery",
    "order.delivery_tbd": "to be calculated",
    "order.total": "Total",
    "order.checkout": "Checkout",
    "order.added": "Added to your order",
    "order.accepted": "Your order has been received!",
    "order.accepted_desc": "We'll call you to confirm.",

    // Gallery
    "gallery.label": "Our Moments",
    "gallery.title": "Gallery",
    "gallery.subtitle":
      "Step into the world of CASA BALA — our atmosphere, dishes and moments we create every day.",

    // Events
    "events.label": "Unforgettable Moments",
    "events.title": "Events",
    "events.subtitle":
      "From wine evenings to private celebrations — CASA BALA is the perfect place for your special moments.",
    "events.upcoming": "Upcoming Events",
    "events.past": "Past Events",
    "events.no_past": "",
    "events.see_more": "See More",
    "events.book": "Book",
    "events.back": "Back to events",
    "events.date_time": "Date & Time",
    "events.place": "Place",
    "events.music_theme": "Music Theme",
    "events.program": "Evening Programme",
    "events.special_menu": "Special Menu",
    "events.reservations": "Reservations",

    // About
    "about.label": "Our Story",
    "about.title": "Tastes with their own story",
    "about.team_label": "The team behind it all",
    "about.team_title": "Our Chefs",
    "about.team_subtitle": "Team",
    "about.team_heading": "Our Team",
    "about.goals_label": "Goals",
    "about.goals_title": "Our Goals",
    "about.history_label": "History",
    "about.history_title": "History",

    // Contact
    "contact.label": "Get in touch with us",
    "contact.title": "Contact",
    "contact.location": "Location",
    "contact.phone": "Phone",
    "contact.email": "Email",
    "contact.hours": "Opening Hours",
    "contact.send_message": "Send a message",
    "contact.name": "Name",
    "contact.email_label": "Email",
    "contact.message": "Message",
    "contact.send": "Send",
    "contact.thanks": "Thank you!",
    "contact.thanks_desc":
      "Your message has been sent. We'll get back to you as soon as possible.",

    // Footer
    "footer.tagline":
      "Mediterranean restaurant in the heart of Sofia. Authentic flavours, fresh ingredients and a warm atmosphere.",
    "footer.navigation": "Navigation",
    "footer.contacts": "Contacts",
    "footer.follow": "Follow us",
    "footer.our_chefs": "Our Chefs",
    "footer.rights": "All rights reserved.",
    "footer.with_love": "Made with love for the Mediterranean",

    // Common
    "common.opening_hours": "Daily: 12:00 - 24:00",
    "common.reservation_hours": "Daily: 10:00 to 22:00",
    "common.work_days": "Monday - Sunday",

    // В dict.en добавете:
"events.wine_evenings": "Wine Evenings",
"events.every_friday": "Every Friday",
"events.wine_evenings_desc": "Tasting of selected wines combined with signature dishes from our chef.",
"events.live_music": "Live Music",
"events.every_saturday": "Every Saturday",
"events.live_music_desc": "Enjoy live music while tasting our Mediterranean delicacies.",
"events.private_events": "Private Events",
"events.by_request": "By request",
"events.private_events_desc": "We organize birthdays, engagements and corporate events with a personalized menu.",
"events.culinary_classes": "Culinary Masterclasses",
"events.once_monthly": "Once a month",
"events.culinary_classes_desc": "Learn the secrets of Mediterranean cuisine from our master chefs.",
"contact.street": "4 Simeonovsko Shose Blvd",
"contact.city": "Sofia, Bulgaria",
"contact.address": '4 Simeonovsko Shose Blvd, Sofia, Bulgaria',
  },

  
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => detectLang());

  useEffect(() => {
    try { localStorage.setItem("casabala_lang", lang); } catch (e) {}
    if (typeof document !== "undefined") document.documentElement.lang = lang;
    if (typeof window !== "undefined") {
      const url = new URL(window.location.href);
      if (lang === "bg") url.searchParams.set("lang", "bg");
      else url.searchParams.delete("lang");
      const next = `${url.pathname}${url.search}${url.hash}`;
      const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      if (next !== current) window.history.replaceState(window.history.state, "", next);
    }
  }, [lang]);

  const setLang = useCallback((l) => {
    if (l !== "bg" && l !== "en") return;
    setLangState(l);
  }, []);

  const t = useCallback(
    (key, fallback) => {
      const v = dict[lang]?.[key];
      if (v !== undefined) return v;
      // Fallback to English then to provided fallback then to key
      return dict.en[key] ?? fallback ?? key;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, t, setLang }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
